import { Common, color, utils, Notation } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Flex, Text, Iconmoon, Modal, Popover } = Common;
const { hexOpacity: percentToHex } = utils;
const { Tag } = Notation;

const Container = styled(Flex)`
  background-color: ${color.light};
  border-radius: 2px;
  margin: auto;
  padding: 20px 28px;
  width: 350px;

  ${({ isFullsize }) =>
    isFullsize &&
    css`
      padding: 36px;
      width: 100%;
    `}
`;

const Description = styled(Text)`
  border-bottom: 1px solid ${color.component};
  font-size: 14px;
  line-height: 15px;
  padding-bottom: 10px;
  width: 100%;
`;

const NotationList = styled.div`
  overflow-y: scroll;
  max-height: 300px;
`;

const NotationBar = styled(Flex)`
  background-color: rgba(235, 160, 49, 0.03);
  cursor: pointer;
  height: 38px;
  width: 100%;
`;

const notationTagVariant = {
  indicator: css`
    background: unset;
    border: unset;
    border-radius: unset;
    height: unset;
    justify-content: center;
    margin-left: 4px;
    margin-right: 0;
    padding: 0;
    text-align: center;
    width: unset;
  `,
  notation: css`
    height: 20px;
    width: 20px;
  `,
  uma: css`
    background: unset;
    border: unset;
    border-radius: unset;
    height: 12px;
    margin-left: 4px;
    margin-right: 0;
    padding: 0;
    width: 22.8px;
    cursor: unset;
  `,
  x: css`
    background: unset;
    border: unset;
    border-radius: unset;
    width: 12px;
    height: 12px;
    margin-left: 4px;
    margin-right: 0;
    padding: 0;
  `,
};

const NotationTag = styled(Tag)`
  align-items: center;
  background: #fef4e8;
  border: 1px solid #f5931b;
  color: #f5931b;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-family: ProximaNovaBd;

  ${({ type }) => notationTagVariant[type]}

  ${({ isNotationBadges }) =>
    isNotationBadges
      ? css`
          margin-right: 0;
        `
      : css`
          margin-bottom: 2px;
        `}
  > .notation-label__icon {
    height: 12px;
    width: 12px;
  }
`;

const BadgeLabelWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  px: '5px',
  py: '2px',
  ml: '5px',
})`
  border: 1px solid ${color.primary};
  border-radius: 4px;
`;

export const BadgeLabelDayTrade = styled(BadgeLabelWrapper)`
  border: 1px solid #8277f8;
  font-size: 12px;
  font-weight: 700;
  color: #8277f8;
  background-color: #f5f0ff;
  padding: 2px 4.5px 2px 2px;
`;

const IconArrow = styled(Iconmoon)`
  color: ${color.yellowSea};
  font-size: 12px;

  &:before {
    content: '\\e968';
  }

  &:hover {
    color: ${color.yellowSea};
  }
`;

const ModalIndicatorBar = styled(Modal).attrs({
  maskStyle: {
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
})`
  .ant-modal-close {
    color: rgba(0, 0, 0, 0.43);

    .ant-modal-close-x {
      font-size: 14px;
      height: 48px;
      line-height: 48px;
      width: 48px;

      .ant-modal-close-icon {
        color: rgba(0, 0, 0, 0.43);
        height: 14px;
        width: 14px;

        > svg {
          fill: inherit;
        }
      }
    }
  }
`;

const PopoverIndicator = styled(Popover).attrs({
  overlayInnerStyle: {
    border: `1px solid ${color.gainsboro}`,
  },
})``;

const NotationBadgeContainer = styled(Tag)`
  width: unset !important;
  min-width: 12px;
  height: 12px;
  gap: 2px;
  border: 1px solid #f5931b;
  border-radius: 2px;
  background-color: #fef4e8;
  padding: 0 2.5px;
  color: #f5931b;
  font-size: 9px;
  line-height: normal;
`;

export {
  Container,
  Description,
  NotationList,
  NotationBar,
  NotationTag,
  BadgeLabelWrapper,
  IconArrow,
  ModalIndicatorBar,
  PopoverIndicator,
  NotationBadgeContainer,
};
